export default __webpack_public_path__ + "static/quote-card-1-674adf8b2b2f1559c54200269747f790.png";